import { AuthCanActivateGuard } from '../auth/_guards/auth.can-activate.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from '@app/auth/_guards/auth.can-deactivate-guard.service';
import { SapDetailsDashboardComponent } from './sap-detailslist/sap-details.component';

let routes: Routes = [
	{
		path: '',
		redirectTo: 'sapdetailsdashboard-detail',
		pathMatch: 'full'
	},
	{
		path: 'sapdetailsdashboard-detail',
		component: SapDetailsDashboardComponent,
		canActivate: [ AuthCanActivateGuard ],
		canDeactivate: [ CanDeactivateGuard ],
		data: {
			label: "SAP_DETAILS",
			expectedRoles: [8,1],
			breadcrumb: "SAP_DETAILS",
		}
	}
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class SapDetailsRoutingModule
 {

}
